import {
  listMessages as publicListMessages,
  sendMessage as publicSendMessage,
} from './crm-inbox-v2-message-messages.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onMessageButtonInteracted as publicOnMessageButtonInteracted } from './crm-inbox-v2-message-messages.public.js';
import { onMessageSentToBusiness as publicOnMessageSentToBusiness } from './crm-inbox-v2-message-messages.public.js';

export const listMessages: MaybeContext<
  BuildRESTFunction<typeof publicListMessages> & typeof publicListMessages
> = /*#__PURE__*/ createRESTModule(publicListMessages);
export const sendMessage: MaybeContext<
  BuildRESTFunction<typeof publicSendMessage> & typeof publicSendMessage
> = /*#__PURE__*/ createRESTModule(publicSendMessage);
/**
 * Triggered when a postback button is clicked.
 */
export const onMessageButtonInteracted: BuildEventDefinition<
  typeof publicOnMessageButtonInteracted
> = createEventModule(publicOnMessageButtonInteracted);
/**
 * Triggered when a visitor, contact, or member
 * sends a message to the business.
 */
export const onMessageSentToBusiness: BuildEventDefinition<
  typeof publicOnMessageSentToBusiness
> = createEventModule(publicOnMessageSentToBusiness);

export {
  Orientation,
  ContentType,
  BadgeVisibility,
  ChannelType,
  MessageVisibility,
  MessageDirection,
  IndicationType,
  PerformedBy,
  SortOrder,
  OverrideSenderOptions,
  WebhookIdentityType,
} from './crm-inbox-v2-message-messages.universal.js';
export {
  Message,
  MessageContent,
  MessageContentPayloadOneOf,
  BasicMessagePayload,
  BasicMessageData,
  BasicMessageDataDataOneOf,
  ImageMessage,
  FileMessage,
  TemplateMessagePayload,
  Button,
  PostbackProperties,
  MinimalMessagePayload,
  FormMessagePayload,
  FormField,
  MediaItem,
  MediaItemMediaOneOf,
  SystemMessagePayload,
  IdentificationData,
  IdentificationDataIdOneOf,
  Badge,
  GetMessageIndicationsRequest,
  GetMessageIndicationsResponse,
  MessageIndication,
  AddMessageIndicationsRequest,
  AddMessageIndicationsResponse,
  MessageSentToParticipant,
  CustomMessageData,
  MessageSentToBusiness,
  InteractionInfo,
  ButtonInteracted,
  ListMessagesRequest,
  CursorPaging,
  Sorting,
  ListMessagesResponse,
  PagingMetadataV2,
  Cursors,
  SendMessageRequest,
  SendMessageResponse,
  GetMessageRequest,
  GetMessageResponse,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  WebhooksIdentificationData,
  WebhooksIdentificationDataIdOneOf,
  BaseEventMetadata,
  EventMetadata,
  MessageButtonInteractedEnvelope,
  MessageSentToBusinessEnvelope,
  ListMessagesOptions,
  SendMessageOptions,
} from './crm-inbox-v2-message-messages.universal.js';
